// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__iHuY8","col":"Table_col__1WNTt","fulfillmentStatus":"Table_fulfillmentStatus__3beV6","emailCol":"Table_emailCol__1XWee"};